import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: [],
  currencyForEdit: {},
  lastError: null,
  image:{}
};
export const callTypes = {
  list: "list",
  action: "action"
};
export const Slice = createSlice({

  name: "currency",
  initialState: initialState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // singleItemFetched
    singleItemFetched: (state, action) => {
      state.actionsLoading = false;
      state.currencyForEdit = action.payload.currencyForEdit;
      state.error = null;
    },
    emptyList: (state, action) => {
      state.error = null;
      state.entities = [];
      // state.totalCount = 0;
      state.exportData = [];
    },
    // listFetched
    listFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
    },
    // itemCreated
    itemCreated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      // state.entities.push(action.payload.item);
      state.entities = [];
    },
    // itemUpdated
    itemUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = [];
      // state.entities = state.entities.map(entity => {
      //   if (entity._id === action.payload.item._id) {
      //     return action.payload.item;
      //   }
      //   return entity;
      // });
    },
    // itemDeleted
    itemDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(el => el.id !== action.payload.id);
    },
    // itemsDeleted
    itemsDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(
        el => !action.payload.ids.includes(el.id)
      );
    },
    // itemStatusUpdated
    itemStatusUpdated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      const { ids, status } = action.payload;
      state.entities = state.entities.map(entity => {
        if (ids.findIndex(id => id === entity.id) > -1) {
          entity.status = status;
        }
        return entity;
      });
    },
    imageUploaded: (state, action) => {
      const { entities, imageField} = action.payload;
      // console.log("entities",action.payload)
      state.error = null;
      state.upload = entities;
      state.imageField = imageField;
    },
  }
});
